import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppSettings } from "projects/portal/src/app.settings";
import { LoyaltyRewardOffer } from "../domain/models/loyalty-reward.model";

@Injectable({ providedIn: "root" })
export class LoyaltyRewardRemote {
  constructor(
    private readonly http: HttpClient,
    private readonly settings: AppSettings,
  ) {}

  getOffer(loanId: number): Observable<LoyaltyRewardOffer> {
    return this.http.get<LoyaltyRewardOffer>(`${this.settings.loans.url}/api/loyalty-reward/${loanId}`);
  }

  acceptOffer(loanId: number): Observable<void> {
    return this.http.post<void>(`${this.settings.loans.url}/api/loyalty-reward/${loanId}/accept`, null);
  }
}
